var map = {
	"./activation-limit.svg": 2976,
	"./application-record.svg": 9782,
	"./back.svg": 9063,
	"./borrow-money.svg": 3946,
	"./bulb.svg": 7703,
	"./check-circle.svg": 4279,
	"./close.svg": 1542,
	"./fail-warn.svg": 2543,
	"./gold.svg": 5644,
	"./home.svg": 6971,
	"./icon-warn.svg": 8030,
	"./immediate-withdrawal.svg": 5171,
	"./input-phone.svg": 9989,
	"./lightning.svg": 5444,
	"./lock.svg": 7491,
	"./money-collect.svg": 8271,
	"./my.svg": 48,
	"./personal-data.svg": 3859,
	"./purse.svg": 7,
	"./rocket.svg": 6722,
	"./safety.svg": 5132,
	"./sound.svg": 3031
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3738;